import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../../shared/services/auth/auth.service';
import { GetDataService } from '../../shared/services/get-data.service';


@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
    form: FormGroup;
    error: string;
    public formSubmitAttempt: boolean;
    public roles = {};

    constructor( public fb: FormBuilder,
        public authService: AuthService,
        public getDataService: GetDataService
        ) {
  }

    ngOnInit( ) {
        this.form = this.fb.group({     // {5}
            email: ['', Validators.required],
            hash_password: ['', Validators.required],
            fullName: ['', Validators.required],
            role: ['', Validators.required]
        });
         this.getDataService.roles().subscribe((data) => {
             this.roles = data;
         }, (err) => {
         });
    }

   isFieldInvalid(field: string) { // {6}
        return (
            (!this.form.get(field).valid && this.form.get(field).touched) ||
            (this.form.get(field).untouched && this.formSubmitAttempt)
        );
    }

    onSubmit(user) {

        if (user) {
            this.authService.register(user)
                .then(
                    res => { // Success
                    },
                    err => {
                        this.error = 'Username or password is incorrect';
                    }
                ); // {7}
        }
        this.formSubmitAttempt = true;             // {8}
    }

}

